import { name, version } from '../../package';

const {
  VUE_APP_AUTH0_CLIENT_ID: clientID,
  VUE_APP_AUTH0_DOMAIN: domain,
  VUE_APP_AUTH0_API_IDENTIFIER: audience,
  VUE_APP_AUTH0_CONNECTION: connection,
  VUE_APP_ATHENA_REGION: region,
  VUE_APP_ATHENA_WORKGROUP: WorkGroup,
  VUE_APP_ATHENA_DATABASE: Database,
  VUE_APP_AWS_ACCESS_KEY_ID: accessKeyId,
  VUE_APP_AWS_SECRET_ACCESS_KEY: secretAccessKey
} = process.env;

export const app = {
  name,
  version
};

export const auth0Config = {
  domain,
  clientID,
  audience,
  connection
};

export const awsConfig = {
  accessKeyId,
  secretAccessKey
};

export const athenaConfig = {
  region,
  WorkGroup,
  Database
};
